import { getDefaultColumnsSettings } from '../TableColumnsSettings';

import { generateZoomInitialTables } from '../../../util/TableTools';
import {
   INGEST_TIME,
   PUBLISH_AUDIO_BITRATE,
   PUBLISH_COUNT,
   PUBLISH_VIDEO_BITRATE,
   STATUS_ERROR_CODES,
   WEBRTC_STOP_REASONS,
   WEBCASTER_VERSIONS,
   WEBRTC_IDX,
} from '../ZoomConstants';
import { format_time_Number, getIntegerWithDecimalSeparator } from '../../../util/NumberFormatter';

export const WEBRTC_SETTINGS = {
   [PUBLISH_COUNT]: {
      title: (term) => `Publishes for ${term}`,
      exIndexName: WEBRTC_IDX,
      initialTable: generateZoomInitialTables(['publishes']),
      path: 'webrtc/count',
      urlAddon: (term, group) => `&zoomWidget=${group}&zoomMetric=${term}`,
      dataAccessFn: (res) => res.data,
      categories: {
         labels: ['Publishes'],
         propNames: ['publishes'],
      },
      dynamicLabelFn: (label, term) => `${label} for '${term}'`,
      dataFieldNames: ['count'],
      columnNames: ['Total count'],
      formatters: [(cell) => getIntegerWithDecimalSeparator(cell)],
      columnsSettings: getDefaultColumnsSettings,
   },
   [STATUS_ERROR_CODES]: {
      title: (term) => `Status/Error code '${term}'`,
      exIndexName: WEBRTC_IDX,
      initialTable: generateZoomInitialTables(['errorcodes']),
      path: 'webrtc/errorcodes',
      urlAddon: (term) => `&zoomMetric=${term}`,
      dataAccessFn: (res) => res.data,
      categories: {
         labels: ['Status/Error code'],
         propNames: ['errorcodes'],
      },
      dynamicLabelFn: (label, term) => `${label} '${term}'`,
      dataFieldNames: ['count'],
      columnNames: ['Total count'],
      formatters: [(cell) => getIntegerWithDecimalSeparator(cell)],
      columnsSettings: getDefaultColumnsSettings,
   },
   [WEBRTC_STOP_REASONS]: {
      title: (term) => `'${term}' as the stop reason`,
      exIndexName: WEBRTC_IDX,
      initialTable: generateZoomInitialTables(['stopreasons']),
      path: 'webrtc/stopReasons',
      urlAddon: (term) => `&zoomMetric=${term}`,
      dataAccessFn: (res) => res.data,
      categories: {
         labels: ['Stop reason'],
         propNames: ['stopreasons'],
      },
      dynamicLabelFn: (label, term) => `${label} '${term}'`,
      dataFieldNames: ['count'],
      columnNames: ['Total count'],
      formatters: [(cell) => getIntegerWithDecimalSeparator(cell)],
      columnsSettings: getDefaultColumnsSettings,
   },
   [PUBLISH_AUDIO_BITRATE]: {
      title: () => 'Audio bitrate',
      exIndexName: WEBRTC_IDX,
      initialTable: generateZoomInitialTables(['bitrates']),
      path: 'webrtc/bitrate/audio',
      dataAccessFn: (res) => res.data,
      categories: {
         labels: ['Audio bitrate'],
         propNames: ['bitrates'],
      },
      dataFieldNames: ['median', 'avg'],
      columnNames: ['Median', 'Average'],
      formatters: [
         (cell) => `${getIntegerWithDecimalSeparator(cell)} kBit/s`,
         (cell) => `${getIntegerWithDecimalSeparator(cell)} kBit/s`,
      ],
      columnsSettings: getDefaultColumnsSettings,
   },
   [PUBLISH_VIDEO_BITRATE]: {
      title: () => 'Video bitrate',
      exIndexName: WEBRTC_IDX,
      initialTable: generateZoomInitialTables(['bitrates']),
      path: 'webrtc/bitrate/video',
      dataAccessFn: (res) => res.data,
      categories: {
         labels: ['Video bitrate'],
         propNames: ['bitrates'],
      },
      dataFieldNames: ['median', 'avg'],
      columnNames: ['Median', 'Average'],
      formatters: [
         (cell) => `${getIntegerWithDecimalSeparator(cell)} kBit/s`,
         (cell) => `${getIntegerWithDecimalSeparator(cell)} kBit/s`,
      ],
      columnsSettings: getDefaultColumnsSettings,
   },
   [INGEST_TIME]: {
      title: () => 'Broadcasting time',
      exIndexName: WEBRTC_IDX,
      initialTable: generateZoomInitialTables(['broadcasttimes']),
      path: 'webrtc/ingesttime',
      dataAccessFn: (res) => res.data,
      categories: {
         labels: ['Broadcasting time'],
         propNames: ['broadcasttimes'],
      },
      dataFieldNames: ['median', 'avg'],
      columnNames: ['Median', 'Average'],
      formatters: [(cell) => format_time_Number(cell), (cell) => format_time_Number(cell)],
      columnsSettings: getDefaultColumnsSettings,
   },
   [WEBCASTER_VERSIONS]: {
      title: (term) => `Webcaster version '${term}'`,
      exIndexName: WEBRTC_IDX,
      initialTable: generateZoomInitialTables(['versions']),
      path: 'webrtc/usedVersions',
      urlAddon: (term) => `&zoomMetric=${term}`,
      dataAccessFn: (res) => res.data,
      categories: {
         labels: ['Webcaster version'],
         propNames: ['versions'],
      },
      dynamicLabelFn: (label, term) => `${label} '${term}'`,
      dataFieldNames: ['count'],
      columnNames: ['Total count'],
      formatters: [(cell) => getIntegerWithDecimalSeparator(cell)],
      columnsSettings: getDefaultColumnsSettings,
   },
};
